import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

function TextInput({
	children,
	error,
	htmlPattern,
	maxLength,
	minLength,
	name,
	pattern,
	register,
	required,
	type,
	...rest
}) {
	const inputClass = classnames("input", { "is-danger": !!error });

	return (
		<div className="field">
			<label htmlFor={name} className="label">
				{children}
			</label>
			<div className="control">
				<input
					{...rest}
					ref={register({ required, pattern, minLength, maxLength })}
					pattern={htmlPattern}
					name={name}
					id={name}
					className={inputClass}
					type={type}
				/>
			</div>
			{error && <p className="help is-primary">{error.message}</p>}
		</div>
	);
}

TextInput.defaultProps = {
	error: null,
	htmlPattern: null,
	maxLength: null,
	minLength: null,
	required: false,
	type: "text"
};

TextInput.propTypes = {
	children: PropTypes.string.isRequired,
	error: PropTypes.shape({}),
	htmlPattern: PropTypes.string,
	maxLength: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.shape({ value: PropTypes.number, message: PropTypes.string })
	]),
	minLength: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.shape({ value: PropTypes.number, message: PropTypes.string })
	]),
	name: PropTypes.string.isRequired,
	pattern: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.shape({ value: PropTypes.object, message: PropTypes.string })
	]),
	register: PropTypes.func.isRequired,
	required: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.shape({ value: PropTypes.bool, message: PropTypes.string })
	]),
	type: PropTypes.string
};

export default TextInput;